import React from 'react';

const SvgCrosshairsGps = ({ title, ...props }) => (
  <svg aria-label={title} viewBox="0 0 24 24" {...props}>
    {title ? <title>{title}</title> : null}
    <circle cx={12} cy={12} r={4} />
    <path d="M21 11c-.5-4.2-3.8-7.5-8-8V1h-2v2c-4.2.5-7.5 3.8-8 8H1v2h2c.5 4.2 3.8 7.5 8 8v2h2v-2c4.2-.5 7.5-3.8 8-8h2v-2h-2zm-9 8c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z" />
  </svg>
);

export default SvgCrosshairsGps;
